
import { defineComponent } from 'vue'
import V2QuantityStepper from './V2QuantityStepper.vue'

export default defineComponent({
  name: 'V2CheckoutPlanSummary',
  components: { V2QuantityStepper },
  props: {
    planName: {
      type: String,
      required: true
    },
    billingInterval: {
      type: String as () => 'monthly' | 'yearly',
      required: true
    },
    seats: {
      type: Number,
      required: true
    },
    minSeats: {
      type: Number,
      default: 1
    },
    maxSeats: {
      type: Number,
      default: 999
    },
    ossTargets: {
      type: Number,
      required: true
    },
    minOssTargets: {
      type: Number,
      default: 3
    },
    includedOssTargets: {
      type: Number,
      default: 3
    },
    aiReviewIncluded: {
      type: String,
      default: '150,000 lines included'
    },
    formattedTotal: {
      type: String,
      default: ''
    },
    nextBillingDate: {
      type: String,
      default: ''
    },
    calculating: {
      type: Boolean,
      default: false
    },
    couponCode: {
      type: String,
      default: ''
    },
    couponError: {
      type: Boolean,
      default: false
    },
    couponLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleInterval() {
      this.$emit(
        'update:billing-interval',
        this.billingInterval === 'monthly' ? 'yearly' : 'monthly'
      )
    }
  }
})
